import { cn } from "@/lib/utils";

export function NextIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-4 w-[9px] text-ruby-red", className)}
      viewBox="0 0 9 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.61 12.933L5.783 7.63.61 2.327A1.385 1.385 0 01.61.4a1.305 1.305 0 011.88 0l6.12 6.273c.52.533.52 1.394 0 1.927l-6.12 6.274c-.52.533-1.36.533-1.88 0-.507-.534-.52-1.408 0-1.941z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PrevIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-4 w-[9px] text-ruby-red", className)}
      viewBox="0 0 9 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.61 12.933L3.436 7.63 8.61 2.327c.52-.533.52-1.394 0-1.927a1.305 1.305 0 00-1.88 0L.61 6.673a1.385 1.385 0 000 1.927l6.12 6.274c.52.533 1.36.533 1.88 0 .507-.534.52-1.408 0-1.941z"
        fill="currentColor"
      />
    </svg>
  );
}
